export const GET_PACKING_LISTS = "GET_PACKING_LISTS";
export const GET_PACKING_LIST = "GET_PACKING_LIST";
export const ADD_PACKING_LIST = "ADD_PACKING_LIST";
export const DELETE_PACKING_LIST = "DELETE_PACKING_LIST";
export const UPDATE_PACKING_LIST = "UPDATE_PACKING_LIST";
